import { render } from "./MarketingWebsitePackage.vue?vue&type=template&id=c78e0252&scoped=true"
import script from "./MarketingWebsitePackage.vue?vue&type=script&lang=js"
export * from "./MarketingWebsitePackage.vue?vue&type=script&lang=js"

import "./MarketingWebsitePackage.vue?vue&type=style&index=0&id=c78e0252&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c78e0252"]])

export default __exports__